// Module
var code = "<span class=\"app-indicator\" data-status=\"\"> <span class=\"symbol\"> <span class=\"recovering icon icon-arrow-to\"> </span> <span class=\"warning-icon icon icon-warning\"></span> </span> </span> ";
// Exports
export default code;